<template>
  <div class="accommodation-variant">
    <div class="accommodation-variant_img">
      <v-carousel
        v-model="carouselModel"
        height="100%"
        hide-delimiters
        :show-arrows="false"
      >
        <v-carousel-item
          v-for="img, i in categoryData.images"
          :key="i"
        >
          <img
            :src="img.src"
            :alt="img.title"
            class="accommodation-variant_img-item"
          >
        </v-carousel-item>
      </v-carousel>
    </div>

    <div
      class="accommodation-variant_img-controls"
      v-if="categoryData.images.length > 1"
    >
      <button
        class="accommodation-variant_img-control accommodation-variant_img-control--prev"
        @click="--carouselModel"
      ></button>
      <button
        class="accommodation-variant_img-control accommodation-variant_img-control--next"
        @click="++carouselModel"
      ></button>
    </div>

    <div class="accommodation-variant_content">
      <span
        class="accommodation-variant_dates"
        v-if="isAdvanced"
      >
        {{variantData.dateRange}}
      </span>
      <span class="accommodation-variant_title">{{categoryData.title}}</span>

      <div class="accommodation-variant_equipment" v-show="isEquipmentShowed">
        <ul class="accommodation-variant_equipment-list">
          <li
            class="accommodation-variant_equipment-item"
            v-for="feature, i in categoryData.features"
            :key="i"
          >
            <div class="accommodation-variant_equipment-icon">
              <img class="accommodation-variant_equipment-icon-img" :src="require(`@/assets/img/category-features/${feature.code}.svg`)" :alt="feature.name">
            </div>
            <span class="accommodation-variant_equipment-item-text">{{feature.name}}</span>
          </li>
        </ul>
      </div>

      <div class="accommodation-variant_footer">
        <ul class="accommodation-variant_features">
          <li class="accommodation-variant_feature">
            <span class="accommodation-variant_feature-icon">
              <img
                src="@/assets/icons/accommodation-variant-place.svg"
                alt="places cnt icon"
                class="accommodation-variant_feature-icon-img"
              >
            </span>
            <span class="accommodation-variant_feature-text">{{dispPlaces}}</span>
          </li>

          <li class="accommodation-variant_feature">
            <span class="accommodation-variant_feature-icon">
              <img
                src="@/assets/icons/accommodation-variant-square.png"
                alt="places cnt icon"
                class="accommodation-variant_feature-icon-img"
              >
            </span>
            <span class="accommodation-variant_feature-text">{{categoryData.square}} кв.м</span>
          </li>
        </ul>

        <div class="accommodation-variant_price">
          <span class="accommodation-variant_price-val"
            v-if="+variantData.price > 0"
          >
            от <span class="accommodation-variant_price-num">{{variantData.price}}</span> Р
          </span>

          <a
            href="javascript:void(0)"
            class="accommodation-variant_check-price"
            v-else
            @click="unavilableDialog = true"
          >
            Узнать цену
          </a>
          <span class="accommodation-variant_price-label">{{dispDaysCnt}} / {{dispGuestsCnt}}</span>
        </div>
      </div>
    </div>

    <span
      class="accommodation-variant_label"
      v-if="variantData.roomCnt < 2"
    >
      Осталось 1 место
    </span>

    <div class="accommodation-variant_actions">
      <a
        class="ui-btn accommodation-variant_action"
        @click.prevent="selectVariant"
      >
        Выбрать
      </a>
    </div>

    <a
      class="accommodation-variant_overlay"
      href="javascript:void(0)"
      @click.prevent="onOverlayClick"
    ></a>

    <v-dialog
      v-model="unavilableDialog"
      max-width="500"
      style="z-index:1002"
    >
      <ui-dialog
        @close="unavilableDialog = false"
      >
        <p class="text text--center">
          На выбранные вами даты нет возможности забронировать путевку.
        </p>
        <p  class="text text--center">
          Обратитесь по номеру: <br><a href="tel:+78001006554">8 (800) 100 65 54</a>.
        </p>

        <template v-slot:actions>
          <v-btn class="ui-btn ui-btn--grey ui-dialog_action" @click.prevent="unavilableDialog = false">Закрыть</v-btn>
        </template>
      </ui-dialog>
    </v-dialog>

    <v-dialog
      width="1033"
      style="z-index:1002"
      v-model="isQuickViewOpened"
    >
      <accommodation-quick-view
        :variantData="variantData"
        @selectVariant="selectVariant"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import AccommodationQuickView from '@/components/AccommodationQuickView.vue'
export default {
  name: 'accommodation-variant',

  components: {
    AccommodationQuickView
  },

  props: {
    variantData: {
      type: Object,
      required: true,
    },
    isAdvanced: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    ...mapState({
      daysCnt: state => state.selection.daysCnt,
    }),

    ...mapGetters({
      getRoomCategoryData: 'dictionaries/getRoomCategoryById',
      guestsCnt: 'selection/getGuestsCnt'
    }),

    dispPlaces() {
      let placesCnt = +this.categoryData.capacity + +this.categoryData.capacityExtra
      let str = `до ${placesCnt}`

      if((placesCnt % 10 === 1) && (placesCnt !== 11)) str += ` места`
      else str += ` мест`

      return str
    },

    dispDaysCnt() {
      let str = `${this.daysCnt}`

      if((+this.daysCnt % 10 === 1) && (+this.daysCnt !== 11)) str += ` ночь`
      else if(+this.daysCnt > 1 && this.daysCnt < 5) str += ` ночи`
      else str += ` ночей`

      return str
    },

    dispGuestsCnt() {
      let str = `${this.guestsCnt}`

      if((+this.guestsCnt % 10 === 1) && (+this.guestsCnt !== 11)) str += ` гость`
      else if(+this.guestsCnt > 1 && this.guestsCnt < 5) str += ` гостя`
      else str += ` гостей`

      return str
    },
  },

  data: () => ({
    categoryData: null,
    carouselModel: 0,
    isQuickViewOpened: 0,
    isEquipmentShowed: false,
    unavilableDialog: false,
  }),

  methods: {
    ...mapActions({
      storeSelectVariant: 'selection/selectVariant',
      changeStep: 'changeStep',
    }),

    selectVariant() {
      this.isQuickViewOpened = 0

      if(+this.variantData.price > 0) {
        this.storeSelectVariant(this.variantData.key)
        this.changeStep(2)
      } else {
        this.unavilableDialog = true
      }
    },

    onOverlayClick() {
      if(+document.documentElement.clientWidth > 600) {
        this.isQuickViewOpened = true
      } else {
        this.isEquipmentShowed = !this.isEquipmentShowed
      }
    },
  },

  created() {
    this.categoryData = this.getRoomCategoryData(this.variantData.roomCategoryId)
  },
}
</script>

<style lang="sass">
.accommodation-variant
  width: 100%
  font-size: 1rem
  box-shadow: 0px px-em(4) px-em(4) rgba(0, 0, 0, 0.25)
  border-radius: px-em(15)
  background-color: #EFEFEF
  position: relative

.accommodation-variant_img
  width: 100%
  height: px-em(140)
  position: relative
  overflow: hidden
  border-top-left-radius: px-em(15)
  border-top-right-radius: px-em(15)

.accommodation-variant_img-container
  width: 100%
  height: 100%
  display: flex
  align-items: center
  justify-content: center


.accommodation-variant_img-item
  flex-shrink: 0
  min-width: 100%
  height: 100%

.accommodation-variant_img-controls
  position: absolute
  top: px-em(113)
  right: px-em(4)
  display: flex
  align-items: center
  z-index: 2

.accommodation-variant_img-control
  width: px-em(24)
  height: px-em(24)
  border-radius: 50%
  background-color: $prime-color
  border: none
  outline: none

  + .accommodation-variant_img-control
    margin-left: px-em(6)

  &::after
    content: ""
    display: block
    width: 100%
    height: 100%

    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='12' fill='none' viewBox='0 0 8 12'%3E%3Cpath fill='%23fff' d='M.636 10.58 4.938 6 .636 1.41 1.96 0l5.637 6-5.637 6-1.324-1.42Z'/%3E%3C/svg%3E")
    background-repeat: no-repeat
    background-position: 50%
    background-size: px-em(7) px-em(12)

  &--prev
    background-color: #535C69

    &::after
      transform: rotate(180deg)

.accommodation-variant_content
  padding: px-em(12) px-em(14) px-em(10)
  color: rgba(83, 92, 105, 1)

.accommodation-variant_dates
  display: block
  margin-bottom: px-em(8,16)
  font-weight: 700

.accommodation-variant_title
  display: block
  margin-bottom: px-em(17, 14)
  font-size: px-em(14)
  line-height: 1.357142
  height: px-em(60)
  overflow: hidden

.accommodation-variant_equipment
  display: none
  margin-bottom: px-em(20,12)

.v-application .accommodation-variant_equipment-list
  padding: 0

.accommodation-variant_equipment-list
  padding: 0
  margin: 0
  list-style: none

.accommodation-variant_equipment-item
  display: flex
  width: 100%
  padding-left: px-em(34,12)
  position: relative

  + .accommodation-variant_equipment-item
    margin-top: px-em(15,24)

.accommodation-variant_equipment-icon
  width: px-em(24,12)
  max-height: px-em(24,12)
  position: absolute
  top: 50%
  left: 0
  transform: translateY(-50%)

.accommodation-variant_equipment-icon-img
  max-width: 100%
  max-height: 100%

.accommodation-variant_footer
  width: 100%
  display: flex

.accommodation-variant_features
  min-width: px-em(1)
  flex-grow: 1
  padding: 0
  margin: 0
  list-style: none

.v-application .accommodation-variant_features
  padding: 0

.accommodation-variant_feature
  position: relative
  padding-left: px-em(30)

  + .accommodation-variant_feature
    margin-top: px-em(1)

.accommodation-variant_feature-icon
  position: absolute
  top: px-em(2)
  left: px-em(2)
  width: px-em(22)
  height: px-em(20)
  display: flex
  align-items: center
  justify-content: center
  margin-top: px-em(-2)

.accommodation-variant_feature-icon-img
  flex-shrink: 0
  max-width: 100%

.accommodation-variant_feature-text
  font-size: .75em


.accommodation-variant_price
  display: flex
  flex-direction: column
  align-items: flex-end
  margin-left: auto
  margin-right: px-em(9)

.accommodation-variant_price-val
  margin-bottom: px-em(7, 14)
  font-size: px-em(14)

.accommodation-variant_price-num
  font-weight: 700
  font-size: px-em(16, 14)

.accommodation-variant_price-label
  font-size: .625em
  color: rgba(141, 141, 141, 1)

.accommodation-variant_actions
  width: 100%
  display: flex
  justify-content: center
  padding-bottom: px-em(14)
  position: relative
  z-index: 2

.accommodation-variant_action
  max-width: px-em(160)
  font-weight: 400

.accommodation-variant_label
  position: absolute
  top: px-em(6,10)
  right: px-em(6,10)
  display: block
  font-size: .625em
  line-height: 1.4
  padding: px-em(7, 10)
  color: #fff
  background-color: rgba(49, 110, 128, 1)
  border-radius: px-em(50)

.accommodation-variant_overlay
  display: block
  position: absolute
  top: 0
  bottom: 0
  left: 0
  right: 0
  z-index: 1

.accommodation-variant_check-price
  z-index: 2

@media screen and (max-width: $mobile-breakpoint)
  .accommodation-variant
    font-size: 1em

  .accommodation-variant_img
    height: px-em(143, 12)

  .accommodation-variant_img-controls
    top: px-em(113, 12)

  .accommodation-variant_img-control
    width: px-em(24, 12)
    height: px-em(24, 12)

    + .accommodation-variant_img-control
      margin-left: px-em(7, 12)

    &::after
      background-size: px-em(7, 12) px-em(12, 12)

  .accommodation-variant_content
    padding: px-em(10, 12) px-em(17, 12) px-em(15, 12)

  .accommodation-variant_title
    font-size: px-em(14, 12)
    margin-bottom: px-em(8, 14)

  .accommodation-variant_equipment
    display: block

  .accommodation-variant_feature

    + .accommodation-variant_feature
      margin-top: px-em(8, 12)

  .accommodation-variant_feature-text
    font-size: 1em

  .accommodation-variant_price-val
    font-size: 1em

  .accommodation-variant_price-label
    font-size: px-em(10, 12)

  .accommodation-variant_actions
    padding-bottom: px-em(24, 12)

  .accommodation-variant_action
    max-width: px-em(188, 12)
    width: 100%
</style>
